/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconTextColor = createReactComponent("text-color", "IconTextColor", [
  ["path", { d: "M9 15v-7a3 3 0 0 1 6 0v7", key: "svg-0" }],
  ["path", { d: "M9 11h6", key: "svg-1" }],
  ["path", { d: "M5 19h14", key: "svg-2" }]
]);

export { IconTextColor as default };
//# sourceMappingURL=IconTextColor.js.map
